import isIGenesysFile from "./isIGenesysFile";
import { IGenesysFile } from "../interface/IMessage";

export default function getFileName(uploadFile: IGenesysFile | File): string {
  if (isIGenesysFile(uploadFile)) {
    return uploadFile.filename;
  } else {
    return uploadFile.name;
  }
}
